import { render, staticRenderFns } from "./DailyPlayersPage.vue?vue&type=template&id=0dd3cbdc&scoped=true"
import script from "./DailyPlayersPage.vue?vue&type=script&lang=js"
export * from "./DailyPlayersPage.vue?vue&type=script&lang=js"
import style0 from "./DailyPlayersPage.vue?vue&type=style&index=0&id=0dd3cbdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd3cbdc",
  null
  
)

export default component.exports